/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Has_Publish_Date_AnyInputs */

const cs_blog_filter_has_publish_date_any = /** @type {(inputs: Blog_Filter_Has_Publish_Date_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libovolné`)
};

const en_blog_filter_has_publish_date_any = /** @type {(inputs: Blog_Filter_Has_Publish_Date_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any`)
};

/**
* | output |
* | --- |
* | "Any" |
*
* @param {Blog_Filter_Has_Publish_Date_AnyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_has_publish_date_any = /** @type {((inputs?: Blog_Filter_Has_Publish_Date_AnyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Has_Publish_Date_AnyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_has_publish_date_any(inputs)
	return cs_blog_filter_has_publish_date_any(inputs)
});